import React,{memo} from 'react'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

const UiSelects  = memo((props) => {
  const { label,value,handleChange,options} = props;
  
  return (
    <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={value}
                label={label}
                onChange={handleChange}
            >
                {options.map((item) => (
                    <MenuItem   
                         key={item.id}
                         value={item.id}
                    >
                        {item.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
  )
})

export default UiSelects